export default __webpack_public_path__ + "static/media/howto-analytics.66cf76c0.svg";